module.exports = __webpack_public_path__ + "static/img/coverImage2.4f021d7c.jpg";